import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col
} from 'react-bootstrap';
import classnames from 'classnames';
import styles from './TransferableSelect.scss';
import SimpleSearchBar from '../../list/SimpleSearchBar.jsx';
import TransferableSelectList from './TransferableSelectList.jsx';
import TransferableSelectItem from './TransferableSelectItem.jsx';
import HTML5Backend from 'react-dnd-html5-backend';
import {DndProvider} from 'react-dnd';
import ItemTypes from './ItemTypes.js';
import ItemPropType from './ItemPropType.js';
import TransferableSelectDragLayer from './TransferableSelectDragLayer.jsx';

class TransferableSelect extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      firstTargeted: -1,
      targetedItems: []
    };
  }

  handleItemsSelected = (items) => {
    let {
      onItemsSelected
    } = this.props;
    this.setState({
      firstTargeted: -1,
      targetedItems: []
    });
    onItemsSelected(items);
  }

  handleItemsRemoved = (items) => {
    let {
      onItemsRemoved
    } = this.props;
    this.setState({
      firstTargeted: -1,
      targetedItems: []
    });
    onItemsRemoved(items);
  }

  getItemSourceList = (item) => {
    let {
      available,
      selected
    } = this.props;
    if (available.includes(item)) {
      return available;
    }
    else {
      return selected;
    }
  }

  untargetItemsNotInList = (list) => {
    let {
      targetedItems
    } = this.state;

    return targetedItems.filter(item => list.includes(item));
  }

  handleItemTargeted = (item) => {
    let targetList = this.getItemSourceList(item);

    this.setState({
      firstTargeted: targetList.indexOf(item),
      targetedItems:[item]
    });
  }

  handleItemShiftTargeted = (item) => {
    let {
      firstTargeted,
      targetedItems
    } = this.state;
    let targetList = this.getItemSourceList(item);
    if (targetedItems.length === 0) {
      firstTargeted = targetList.indexOf(item);
    }
    let clickedIndex = targetList.indexOf(item);
    targetedItems = firstTargeted <= clickedIndex
      ? targetList.slice(firstTargeted, clickedIndex + 1)
      : targetList.slice(clickedIndex, firstTargeted + 1);
    this.setState({
      firstTargeted,
      targetedItems
    });
  }

  handleItemCtrlTargeted = (item) => {
    let targetList = this.getItemSourceList(item);
    let targetedItems = this.untargetItemsNotInList(targetList);
    let firstTargeted = this.state.firstTargeted;
    if (targetedItems.includes(item)) {
      targetedItems = targetedItems.filter(i => i !== item);
      firstTargeted = targetedItems.length > 0 ? firstTargeted : -1;
    }
    else {
      firstTargeted = targetList.indexOf(item);
      targetedItems = [...targetedItems, item];
    }
    this.setState({
      firstTargeted,
      targetedItems
    });
  }

  render() {
    let {
      targetedItems
    } = this.state;
    let {
      available,
      availableTitle,
      availableHasMore,
      availableNoResultsText,
      availableLoading,
      onAvailableRequestMore,
      availableSearchTerm,
      onAvailableSearchTermChange,
      onAvailableSearched,
      selected,
      selectedTitle,
      selectedHasMore,
      selectedNoResultsText,
      selectedLoading,
      onSelectedRequestMore,
      selectedSearchTerm,
      onSelectedSearchTermChange,
      onSelectedSearched,
      dropPrompt
    } = this.props;
    return (
      <DndProvider backend={HTML5Backend}>
        <div className={styles.transferrableSelect}>
          <TransferableSelectDragLayer />
          <div className={classnames(styles.selectSide, styles.left)}>
            <h4>{availableTitle}</h4>
            {
              onAvailableSearched &&
              <SimpleSearchBar
                value={availableSearchTerm}
                onChange={onAvailableSearchTermChange}
                onSearch={onAvailableSearched}
                className={styles.search}
                autosearch
              />
            }
            <TransferableSelectList
              type={ItemTypes.SELECTED}
              onItemsDropped={this.handleItemsRemoved}
              dropPrompt={dropPrompt}
              hasMore={availableHasMore}
              loading={availableLoading}
              onRequestMore={onAvailableRequestMore}
              noResultsText={availableNoResultsText}
            >
              {
                available.map(item =>
                  <TransferableSelectItem
                    key={item.key}
                    type={ItemTypes.AVAILABLE}
                    item={item}
                    targetedItems={targetedItems}
                    onClick={this.handleItemTargeted}
                    onShiftClick={this.handleItemShiftTargeted}
                    onCtrlClick={this.handleItemCtrlTargeted}
                  />
                )
              }
            </TransferableSelectList>
          </div>
          <div className={styles.selectSide}>
            <h4>{selectedTitle}</h4>
            {
              onSelectedSearched &&
              <SimpleSearchBar
                value={selectedSearchTerm}
                onChange={onSelectedSearchTermChange}
                onSearch={onSelectedSearched}
                className={styles.search}
                autosearch
              />
            }
            <TransferableSelectList
              type={ItemTypes.AVAILABLE}
              onItemsDropped={this.handleItemsSelected}
              dropPrompt={dropPrompt}
              hasMore={selectedHasMore}
              loading={selectedLoading}
              onRequestMore={onSelectedRequestMore}
              noResultsText={selectedNoResultsText}
            >
              {
                selected.map(item =>
                  <TransferableSelectItem
                    key={item.key}
                    type={ItemTypes.SELECTED}
                    item={item}
                    targetedItems={targetedItems}
                    onClick={this.handleItemTargeted}
                    onShiftClick={this.handleItemShiftTargeted}
                    onCtrlClick={this.handleItemCtrlTargeted}
                  />
                )
              }
            </TransferableSelectList>
          </div>
        </div>
      </DndProvider>
    );
  }
}

TransferableSelect.propTypes = {
  available: PropTypes.arrayOf(ItemPropType),
  selected: PropTypes.arrayOf(ItemPropType),
  availableTitle: PropTypes.node,
  availableHasMore: PropTypes.bool,
  availableSearchTerm: PropTypes.string,
  availableNoResultsText: PropTypes.node,
  availableLoading: PropTypes.bool,
  onAvailableSearchTermChange: PropTypes.func,
  onAvailableSearched: PropTypes.func,
  onAvailableRequestMore: PropTypes.func,
  selectedTitle: PropTypes.node,
  selectedHasMore: PropTypes.bool,
  selectedSearchTerm: PropTypes.string,
  selectedNoResultsText: PropTypes.node,
  selectedLoading: PropTypes.bool,
  onSelectedSearchTermChange: PropTypes.func,
  onSelectedSearched: PropTypes.func,
  onSelectedRequestMore: PropTypes.func,
  onItemsSelected: PropTypes.func.isRequired,
  onItemsRemoved: PropTypes.func.isRequired,
  dropPrompt: PropTypes.node.isRequired
};

TransferableSelect.defaultProps = {
  available: [],
  availableTitle: 'Available',
  selected: [],
  selectedTitle: 'Selected',
};

export default TransferableSelect;